import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const emptyShop = {
  shopName: "",
  address: "",
  phone: "",
  email: "",
  logoUrl: "",
  website: "",
};

function ShopSettings() {
  const [shop, setShop] = useState(emptyShop);
  const [message, setMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const token = localStorage.getItem("token")?.trim();

  const authHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const loadShop = async () => {
    try {
      const res = await axios.get(`${API_URL}/shop`, authHeaders);

      setShop({
        shopName: res.data.shopName || "",
        address: res.data.address || "",
        phone: res.data.phone || "",
        email: res.data.email || "",
        logoUrl: res.data.logoUrl || "",
        website: res.data.website || "",
      });
    } catch (error) {
      setMessage(error.response?.data?.message || "Could not load shop settings.");
    }
  };

  useEffect(() => {
    loadShop();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setShop((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const saveShop = async (e) => {
    e.preventDefault();

    try {
      setIsSaving(true);

      const res = await axios.put(`${API_URL}/shop`, shop, authHeaders);

      setShop({
        shopName: res.data.shopName || "",
        address: res.data.address || "",
        phone: res.data.phone || "",
        email: res.data.email || "",
        logoUrl: res.data.logoUrl || "",
        website: res.data.website || "",
      });

      setMessage("Shop settings saved successfully.");
    } catch (error) {
      setMessage(error.response?.data?.message || "Could not save shop settings.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={styles.page}>
      <h1>Shop Settings</h1>
      <p style={styles.subtitle}>
        These details appear on receipts, dashboard, and customer display.
      </p>

      {message && <p style={styles.message}>{message}</p>}

      <form onSubmit={saveShop} style={styles.card}>
        <label style={styles.label}>
          Shop Name
          <input
            name="shopName"
            value={shop.shopName}
            onChange={handleChange}
            placeholder="African Grocery Liverpool"
            style={styles.input}
            required
          />
        </label>

        <label style={styles.label}>
          Address
          <textarea
            name="address"
            value={shop.address}
            onChange={handleChange}
            placeholder="123 Smith Street, Liverpool"
            style={styles.textarea}
          />
        </label>

        <label style={styles.label}>
          Phone
          <input
            name="phone"
            value={shop.phone}
            onChange={handleChange}
            placeholder="07400 123456"
            style={styles.input}
          />
        </label>

        <label style={styles.label}>
          Email
          <input
            name="email"
            value={shop.email}
            onChange={handleChange}
            placeholder="shop@email.com"
            style={styles.input}
          />
        </label>

        <label style={styles.label}>
          Logo URL
          <input
            name="logoUrl"
            value={shop.logoUrl}
            onChange={handleChange}
            placeholder="Optional logo image URL"
            style={styles.input}
          />
        </label>

        <label style={styles.label}>
          Website
          <input
            name="website"
            value={shop.website}
            onChange={handleChange}
            placeholder="https://yourstore.com"
            style={styles.input}
          />
          <div style={styles.field}>
            <label style={styles.label}>Receipt Footer</label>

            <textarea
              name="receiptFooter"
              value={shop.receiptFooter}
              onChange={handleChange}
              placeholder="Thank you for shopping with us."
              style={styles.textarea}
            />
          </div>
        </label>

        <button type="submit" disabled={isSaving} style={styles.button}>
          {isSaving ? "Saving..." : "Save Shop Settings"}
        </button>
      </form>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    padding: "24px",
    background: "#f4f6f8",
    fontFamily: "Arial, sans-serif",
  },
  subtitle: {
    color: "#555",
  },
  message: {
    padding: "12px",
    background: "#fff3cd",
    borderRadius: "8px",
    marginBottom: "16px",
  },
  card: {
    maxWidth: "620px",
    background: "white",
    padding: "22px",
    borderRadius: "14px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  label: {
    display: "block",
    marginBottom: "14px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    marginTop: "6px",
    padding: "14px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    minHeight: "90px",
    marginTop: "6px",
    padding: "14px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: "16px",
    fontSize: "16px",
    borderRadius: "10px",
    border: "none",
    cursor: "pointer",
    marginTop: "10px",
  },
  textarea: {
  width: "100%",
  minHeight: "100px",
  padding: "14px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "16px",
  resize: "vertical",
  boxSizing: "border-box",
},
};

export default ShopSettings;